import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import axios from "axios";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { deleteStatus, formUpdateStatus, updateFormInfo } from "../../../redux/slice/formUpdateSlice";
import { POADCAST_API_PATH } from "../../../network/config/apiPaths";
import { consoleLog } from "../../../utils/log-utils";
import { updateMessage } from "../../../redux/slice/toastSlice";
import DeleteBanner from "../../banners/crudOperations/deleteBanner";
import PoadcastAlbumItem from "./poadcast-album-item";
import AddPoadcastAlbum from "./add-album";

function PoadcastAlbum() {
  const dispatch = useDispatch();
  const showRequestForm = useSelector(formUpdateStatus);
  // list of items
  const [resultList, setResultList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const showDeleteAlert=useSelector(deleteStatus);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    let data=await axios.get(API_CONFIG.API_HOST+POADCAST_API_PATH.POADCAST_ALBUM,{
      headers:API_HEADERS
    })
    consoleLog("Album data",data)
    setResultList(data.data.result)
    // await dispatch(listAction(dispatch)).then((reponse) => {
    //   if (reponse.result) {
       
    //     setResultList(reponse.result);
    //   }
    // });
  };
  function handleSearchClick(e) {
    const searchTerm = e.target.value;
    setSearchVal(searchTerm);
    if (searchTerm === "") {
      setResultList(resultList);
      setFilterList([]);
    } else {
      const filterBySearch = resultList.filter((item) => {
        if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          return item;
        }
      });
      setFilterList(filterBySearch);
    }
  }

  const onSubmit = () => {
    dispatch(updateFormInfo({ displayForm: false, formData: {} }));
    dispatch(
      updateMessage({
        display: true,
        message: "Record updated",
      })
    );
    setResultList([]);
    setSearchVal("");
    setFilterList([]);

    loadData();
  };
  const onDelete = () => {
    
    dispatch(
      updateMessage({
        display: true,
        message: "Record deleted",
      })
    );
    // setBannerList([]);
    loadData()

    // loadData();
  };


  return (
    <>
      {showRequestForm && (
        <AddPoadcastAlbum
          onSubmit={() => {
            onSubmit();
          }}
          type="PRODUCT"
        />
      )}
      {showDeleteAlert && (
        <DeleteBanner
          onSubmit={() => {
            onSubmit();
          }}
         
        />
      )}
      <main className="container-fluid dashboard">
        <div className="row m-3">
          <div className="row justify-content-around tble">
            <div className="col-6">
              <h3 className="dashboard-title">Poadcast Album</h3>
            </div>
            <div className="mr-auto col-6 text-end">
              <button
                type="button"
                className="mr-auto btn add-button-color"
                onClick={() => {
                  dispatch(
                    updateFormInfo({
                      displayForm: true,
                      formData: {},
                    })
                  );
                }}
              >
                + Add Album
              </button>
            </div>
          </div>
        </div>
        <div className="row m-3">
          {/* <div className="col-md-3">
            <div className="form-group">
              <label>Search Tags</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={searchVal}
                placeholder="Enter Tag name"
                onChange={(e) => handleSearchClick(e)}
              />
            </div>
          </div> */}
          <div className="col-md-12 card-1">
            <table className="table table-hover align-middle">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">sno</th>
                  {/* <th scope="col">Image</th> */}
                  <th scope="col">Name</th>
                  {/* <th scope="col">Type</th> */}
                  <th scope="col">Album</th>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              {searchVal === "" && resultList && resultList.length > 0 ? (
                <tbody>
                  {resultList.map((item, i) => {
                    return <PoadcastAlbumItem item={item} key={item.id} sno={i+1}/>;
                  })}
                </tbody>
              ) : filterList.length > 0 ? (
                <tbody>
                  {filterList.map((item, i) => {
                    return <PoadcastAlbumItem item={item} key={item.id} sno={i+1} />;
                  })}
                </tbody>
              ) : (
                <p>No Data found</p>
              )}
            </table>
          </div>
        </div>
      </main>
    </>
  );
}

export default PoadcastAlbum;
